import { render, staticRenderFns } from "./reportCustomComponentRelManageList.vue?vue&type=template&id=2d2f1119&scoped=true"
import script from "./reportCustomComponentRelManageList.vue?vue&type=script&lang=js"
export * from "./reportCustomComponentRelManageList.vue?vue&type=script&lang=js"
import style0 from "./reportCustomComponentRelManageList.vue?vue&type=style&index=0&id=2d2f1119&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2f1119",
  null
  
)

export default component.exports